<template>
  <div>
    <Head title="Inventaris - Item Asset" />
    <h1 class="mb-8 text-3xl font-bold">
      Inventaris
      <span class="text-indigo-400 font-medium"> / </span>
      Item Asset
    </h1>
    <div class="sectors-center flex items-center justify-between mb-6">
      <search-filter
        v-model="form.search"
        class="mr-4 w-full max-w-md"
        @reset="reset">
        <select v-model="form.project" class="form-select mt-1 w-full">
          <option :value="null">
            [ALL PROJECT]
          </option>
          <option
            v-for="project in projects"
            :key="project.id"
            :value="project.id">
            {{ project.title }}
          </option>
        </select>
        <select v-model="form.event" class="form-select mt-1 w-full">
          <option :value="null">
            [ALL MUTASI]
          </option>
          <option
            v-for="event in assetEvents"
            :key="event.id"
            :value="event.id">
            {{ event.name }}
          </option>
        </select>
      </search-filter>
      <div class="flex items-center">
        <button
          :disabled="selectedAssets.length === 0 || exporting"
          @click="exportLabels"
          class="btn-indigo flex items-center justify-center mr-2 px-4 py-3">
          <div v-if="exporting" class="flex items-center">
            <svg
              class="-ml-1 mr-3 w-5 h-5 text-white animate-spin"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24">
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4" />
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            <span>Mengekspor...</span>
          </div>
          <span v-else>Ekspor Label</span>
        </button>
        <Link class="btn-indigo" href="/item_assets/create">
          <span>Create</span>
          <span class="hidden md:inline">&nbsp;Item Asset</span>
        </Link>
      </div>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">
              <input v-model="selectAll" type="checkbox">
            </th>
            <th class="pb-4 pt-6 px-6">
              Nama Asset
            </th>
            <th class="pb-4 pt-6 px-6">
              No. Inventaris
            </th>
            <th class="pb-4 pt-6 px-4">
              Serial Num
            </th>
            <th class="pb-4 pt-6 px-4">
              Penanggung Jawab
            </th>
            <th class="pb-4 pt-6 px-4">
              Sumber Dana (PROJECT)
            </th>
            <th class="pb-4 pt-6 px-4">
              Tgl. Pengadaaan
            </th>
            <th class="pb-4 pt-6 px-4">
              Harga
            </th>
            <th class="pb-4 pt-6 px-4">
              Kondisi
            </th>
            <th class="pb-4 pt-6 px-4">
              Mutasi Terbaru
            </th>
            <th class="pb-4 pt-6 px-4">
              Last Updated
            </th>
            <th class="pb-4 pt-6 px-4">
              Jenis Barang (Main-Sub)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="asset in itemAssets.data"
            :key="asset.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="px-6 border-t">
              <input
                v-model="selectedAssets"
                :value="asset.id"
                type="checkbox">
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/item_assets/${asset.id}/edit`"
                tabindex="-1">
                {{ asset.item_name }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/item_assets/${asset.id}/edit`"
                tabindex="-1">
                {{ asset.asset_no }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/item_assets/${asset.id}/edit`"
                tabindex="-1">
                {{ asset.serial_num }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/item_assets/${asset.id}/edit`"
                tabindex="-1">
                {{ asset.employee_name }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/item_assets/${asset.id}/edit`"
                tabindex="-1">
                {{ asset.project_name }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/item_assets/${asset.id}/edit`"
                tabindex="-1">
                {{ asset.purchase_date }}
              </Link>
            </td>
            <td class="text-right border-t">
              <Link
                class="flex items-end justify-end px-6 py-4"
                :href="`/item_assets/${asset.id}/edit`"
                tabindex="-1">
                {{ formatNumber(asset.purchase_price) }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/item_assets/${asset.id}/edit`"
                tabindex="-1">
                {{ asset.condition }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/item_assets/${asset.id}/edit`"
                tabindex="-1">
                {{ asset.last_event }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/item_assets/${asset.id}/edit`"
                tabindex="-1">
                {{ asset.updated_at }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-4 py-4"
                :href="`/item_assets/${asset.id}/edit`"
                tabindex="-1">
                <span
                  v-if="asset.asset_type_code"
                  class="font-mono text-indigo-600 mr-2">
                  [{{ asset.asset_type_code }}]
                </span>
                {{ asset.asset_type }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link
                class="flex items-center px-4"
                :href="`/item_assets/${asset.id}/edit`"
                tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="itemAssets.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="13">
              No Asset found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination
      class="mt-6"
      :links="itemAssets.links"
      with-per-page />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue'

export default {
    layout: Layout,
}
</script>

<script setup>
import { ref, watch, defineProps } from 'vue'
import { Head, Link, router } from '@inertiajs/vue3'
import Pagination from '@/Shared/Pagination.vue'
import SearchFilter from '@/Shared/SearchFilter.vue'
import Icon from '@/Shared/Icon.vue'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import axios from 'axios'

const props = defineProps({
    projects: Object,
    assetEvents: Object,
    filters: Object,
    itemAssets: Object,
})

const form = ref({
    search: props.filters.search,
    project: props.filters.project,
    event: props.filters.event,
})

const exporting = ref(false)
const selectAll = ref(false)
const selectedAssets = ref([])

watch(selectAll, (newValue) => {
    if (newValue) {
        selectedAssets.value = props.itemAssets.data.map((asset) => asset.id)
    } else {
        selectedAssets.value = []
    }
})

watch(
    selectedAssets,
    (newValue) => {
        if (newValue.length === 0) {
            selectAll.value = false
        } else if (newValue.length === props.itemAssets.data.length) {
            selectAll.value = true
        }
    },
    { deep: true },
)

const reset = () => {
    form.value = mapValues(form.value, () => null)
}

const throttleWatch = throttle(() => {
    router.get('/item_assets', pickBy(form.value), { preserveState: true })
}, 350)

watch(form, throttleWatch, { deep: true })

function formatNumber (num) {
    return num ? num.toLocaleString('id-ID') : '0'
}

function exportLabels () {
    exporting.value = true
    axios
        .post(
            '/item_assets/export-labels',
            {
                ids: selectedAssets.value,
            },
            {
                responseType: 'blob',
            },
        )
        .then((response) => {
            const skipped = response.headers['x-skipped-asset-nos']
            if (skipped) {
                // ponytail: alert until a toast channel exists for blob responses
                alert('Asset tanpa QR dilewati: ' + decodeURIComponent(skipped))
            }
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            // Server sets a timestamped filename in Content-Disposition; the
            // epoch fallback covers a stripped header (CORS expose-headers).
            const disposition = response.headers['content-disposition'] ?? ''
            link.download = disposition.match(/filename="?([^";]+)"?/)?.[1] ?? `item-asset-labels-${new Date().getTime()}.xlsx`
            link.click()
            URL.revokeObjectURL(link.href)
        })
        .catch((error) => {
            console.error('Error exporting labels:', error)
            alert('Gagal mengekspor label. Lihat console untuk detail.')
        })
        .finally(() => {
            exporting.value = false
        })
}
</script>
